import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { LayoutPlain, Header, Footer } from 'components/layout'
import { form, meta } from 'helpers/decorators'
import { Button, Module } from '../../../components/misc'
import { FormattedMessage } from 'react-intl'
import queryString from 'query-string'
import { get } from 'lodash'
import { apiAssessors } from '../../../helpers/decorators/api'
import { LoaderOverlay } from '../../../components/loaders'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { Textarea } from '../../../components/fields'
import config from '../../../config'


@meta({ title: 'Accept activity', intlKey: 'route.accept_activity' })
@apiAssessors()
@form({
  form: 'rejectActivity',
  disableHook: true,
})
@connect(
  state => ({
    isSubmitting: get(state, 'api.assessor.assessors.loading'),
    submitted: get(state, 'api.assessor.assessors.loaded')
  }),
  { push }
)
class RejectActivity extends Component {
  static propTypes = {
    location: PropTypes.object,
    acceptActivityByLink: PropTypes.func,
    isSubmitting: PropTypes.bool,
    submitted: PropTypes.bool,
    handleSubmit: PropTypes.func,
    onRejectActivity: PropTypes.func,
    push: PropTypes.func
  }

  handleSubmit = fields => {
    const { onRejectActivity } = this.props

    const query = queryString.parse(this.props.location.search)

    onRejectActivity(fields, get(query, 'authorizationCode')).then(() => this.props.push(`${config.publicPath}/activity/reject`))
  }

  render() {
    const { isSubmitting, submitted, handleSubmit } = this.props

    return (
      <LayoutPlain
        header={<Header />}
        footer={<Footer />}
        body={[<Module>
          <LoaderOverlay isLoading={isSubmitting}>
            <div className="text--left">
            <h2 className="alpha nowrap">
              <FormattedMessage
                id="moduleTitle.reject_activity"
                defaultMessage="Reject Activity"
              />
            </h2>
            </div>
            <div>
              {!submitted && <form onSubmit={handleSubmit(this.handleSubmit)}>

                <div className="col-xs-12">
                  <Textarea
                    name='reason'
                    intlKey="label.reason"
                  />
                </div>
                <div className="col-xs-12 text--right">
                  <Button
                    intlKey="button.reject"
                    type="submit"
                  >
                    Reject
                  </Button>
                </div>

              </form>}
              {submitted && <p className="delta text--left">
                <FormattedMessage
                  id="notifications.activity_was_rejected"
                  defaultMessage="Activity was rejected"
                />
              </p>}
            </div>

          </LoaderOverlay>
        </Module>]}
        colWidth="305px"
      />

    )
  }
}

export default RejectActivity
